import * as $ from 'jquery';
import DatePicker from 'vue2-datepicker';
import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";

import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';

// Constants
import { STATUS_CODES, SUCCESS_MSG } from '@/app/constants/status-constants';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util';

const REMINDER_TYPE_OPTIONS = {
    PARASITES: 'Parasites',
    VACCINATION: 'Vaccination',
    VET: 'Vet',
    OTHERS: 'Others',
};
export default {
    name: 'ModalAddEditReminderNote',
    components: {
        DatePicker
    },
    directive: {},
    filters: {},
    mixins: [
        toastMessageMixins, 
        dateMixins
    ],
    props: {},
    data() {
        return {
            isAPILoading: false,
            reminderDetails: {
                reminderType: '',
                otherTypes: '',
                notes: '',
                reminderDate: '',
            },
            initialReminderDate: '',
            modalContent: {},
            saveButtonText: 'Save',
            actionText: 'Add',
            cancelButtonText: 'Cancel',
            reminderTypeOptions: [
                { id: 1, name: REMINDER_TYPE_OPTIONS.PARASITES },
                { id: 2, name: REMINDER_TYPE_OPTIONS.VACCINATION },
                { id: 3, name: REMINDER_TYPE_OPTIONS.VET },
                { id: 4, name: REMINDER_TYPE_OPTIONS.OTHERS },
            ],
            puppyList: [],
            REMINDER_TYPE_OPTIONS
        }
    },
    computed: {
        validationRules() {
			let fields = {
				reminderDetails: {
                    reminderType: {},
                    otherType: {},
                    reminderDate: {},
				}
			}

			fields.reminderDetails = vuelidateUtil.setFieldsRequired(fields.reminderDetails, true);
			fields.reminderDetails = vuelidateUtil.setIsFutureDateAndTime(fields.reminderDetails, 'reminderDate');

			return fields;
        },
    },
    watch: {},
    created() {},
    methods: {
        show(content) {
            this.clearFields();
            this.modalContent = content;
            if (this.modalContent.reminder && this.modalContent.action === "Edit") {
                this.saveButtonText = "Update"
                this.actionText = "Update"
                this.setFields(this.modalContent.reminder)
            }

            if (this.modalContent.reminder && this.modalContent.action === "Notif") {
                this.saveButtonText = "Update"
                this.actionText = ""
                this.cancelButtonText = "Got it"
                this.setFields(this.modalContent.reminder)
            }
            $(this.$refs.modalAddEditReminderNote).modal('show');
        },

        setFields(reminder) {
            const { reminderDateTime, ...rest } = reminder
            const formatLocalDateTime = new Date(this.formatDateTime(reminderDateTime))

            this.reminderDetails = { ...rest, reminderDate: formatLocalDateTime }
            this.initialReminderDate = formatLocalDateTime.toISOString();
        },

        disableEdit() {
            return this.modalContent.action === 'Notif'
        },

        async onSaveReminderNote() {
            const { ERROR_SAVE_REMINDER, SUCCESS_SAVE_REMINDER, SUCCESS_UPDATE_REMINDER, ERROR_UPDATE_REMINDER } = this.toastMessages.reminder();
            const includeOtherType = this.reminderDetails.reminderType === REMINDER_TYPE_OPTIONS.OTHERS;
            const isUpdate = this.modalContent.action === "Edit"
            //Validate Fields
            const { reminderDetails: { reminderType, reminderDate, otherType } } = this.$v;
            reminderDate.$touch();
            reminderType.$touch();
            includeOtherType && otherType.$touch();

            
            if (reminderType.$invalid || reminderDate.$invalid || (includeOtherType && otherType.$invalid)) {
                return;
            }

            const date = new Date(this.reminderDetails.reminderDate).toISOString();
            
            let requestBody = {
                matingId: this.modalContent.matingId,
                reminderType: includeOtherType ? this.reminderDetails.otherType : this.reminderDetails.reminderType,
                notes: this.reminderDetails.notes,
                reminderDate: date,
            };

            if (this.reminderDetails.id && isUpdate) {
                requestBody.id = this.reminderDetails.id
                requestBody.isDateChanged = this.initialReminderDate != date
            }

            try {
                this.isAPILoading = true;
                const response = isUpdate
                    ? await breedingManagementService.updateLitterReminderNotes(requestBody)
                    : await breedingManagementService.saveLitterReminderNotes(requestBody);

                if (response.status === STATUS_CODES.SUCCESS_POST) {
                    this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, isUpdate ? SUCCESS_UPDATE_REMINDER : SUCCESS_SAVE_REMINDER);
                    this.refreshTable();
                } else {
                    this.hideModal();
                    this.showAPIErrorToast(isUpdate ? ERROR_UPDATE_REMINDER : ERROR_SAVE_REMINDER, res);
                }
                
            } catch (err) {
                this.hideModal();
                this.showAPIErrorToast(ERROR_SAVE_REMINDER, err);
            } finally {
                this.isAPILoading = false;
            }


        },

        clearFields() {
            this.reminderDetails = {
                reminderType: '',
                otherTypes: '',
                notes: '',
                reminderDate: '',
            },
            this.saveButtonText = "Save"
            this.actionText = "Add"
            this.cancelButtonText = "Cancel"
            this.$v.$reset();
        },

        onBlur(field) {
			const { reminderDetails: { reminderType, reminderDate, otherType } } = this.$v;
            const fieldsToTouch = {
                type: reminderType,
                reminderDate,
                otherType,
            };

            if (field === 'otherTypes' && this.reminderDetails.reminderType !== 'Others') {
                return;
            }

            if (fieldsToTouch[field]) {
                fieldsToTouch[field].$touch();
            }
        },

        hideModal() {
            // Remove the reminderId query parameter
            const query = { ...this.$route.query };
            delete query.reminderId;
            this.$router.replace({ query });

            // Hide modal
			$(this.$refs.modalAddEditReminderNote).modal('hide');
        },
        refreshTable() {
            this.hideModal();
            this.$emit('getTableContent');
        },
    },

    validations() {
		return this.validationRules;
	}
}